function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHandleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 10a1 1 0 011-1h18a1 1 0 110 2H7a1 1 0 01-1-1zM6 16a1 1 0 011-1h18a1 1 0 110 2H7a1 1 0 01-1-1zM6 22a1 1 0 011-1h18a1 1 0 110 2H7a1 1 0 01-1-1z",
    fill: props.color
  }));
}

export default SvgIconHandleFilled;